import { Injector, StaticProvider } from '@angular/core';
import { DatasourceServiceDef, ModelingTabs, provideDatasource } from '@y42/datasource';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { ImpexServiceDef, provideImpex } from '@y42/impex';
import { JobServiceDef, provideJob } from '@y42/job';
import { Y42FeatureType } from '@y42/json-schema';
import {
  SqlModelingAclService,
  SqlModelingDataTestService,
  SqlModelingGitService,
  SqlModelingJobSettingsValidationService,
  SqlModelingQuery,
  SqlModelingService,
  SqlModelingStore,
  SqlModelingTableJobQuery,
  SqlModelingTableJobService,
  SqlModelingTableJobStore,
  SqlModelingTableQuery,
  SqlModelingTableService,
  SqlModelingTableStore,
} from '@y42/sql-model';
import { DataTestServiceDef, provideDataTest } from '../../data-test/provide-data-test';

const SqlModellingFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.SqlModel,
    GIT_FOLDER: Y42GitFolders.SqlModel,
    FEATURE_ROUTE: Y42Routes.SqlModeling,
    DETAIL_TABS: ModelingTabs,
    AbstractFeatureService: SqlModelingService,
    AbstractFeatureQueryEntity: SqlModelingQuery,
    AbstractFeatureEntityStore: SqlModelingStore,
    AbstractFeatureGitService: SqlModelingGitService,
    AbstractFeatureAclService: SqlModelingAclService,
    AbstractFeatureChildQueryEntity: SqlModelingTableQuery,
  };
};

const SqlModellingDatasourceProviders: () => DatasourceServiceDef = () => {
  return {
    DatasourceService: SqlModelingService,
    DatasourceStore: SqlModelingStore,
    DatasourceQuery: SqlModelingQuery,
    DatasourceTableService: SqlModelingTableService,
    DatasourceTableStore: SqlModelingTableStore,
    DatasourceTableQuery: SqlModelingTableQuery,
    DatasourceTableJobStore: SqlModelingTableJobStore,
    DatasourceTableJobQuery: SqlModelingTableJobQuery,
    DatasourceGitService: SqlModelingGitService,
    DatasourceJobSettingsValidationService: SqlModelingJobSettingsValidationService,
  };
};

const SqlModellingJobProviders: () => JobServiceDef = () => {
  return {
    JobService: SqlModelingTableJobService,
    JobQuery: SqlModelingTableJobQuery,
    JobStore: SqlModelingTableJobStore,
    JOB_OVERVIEW_MODELS: (injector: Injector) => injector.get(SqlModelingQuery).activeTables$,
    ACTIVE_JOB_OVERVIEW_MODEL: (injector: Injector) => injector.get(SqlModelingTableQuery).active$,
  };
};

const SqlModelingDataTestProviders: () => DataTestServiceDef = () => ({
  DataTestService: SqlModelingDataTestService,
  DataTestParentQuery: SqlModelingTableQuery,
});

const SqlModelingImpexProviders: () => ImpexServiceDef = () => ({
  ImpexService: SqlModelingService,
  ImpexChildService: SqlModelingTableService,
  ImpexQuery: SqlModelingQuery,
  ImpexChildQuery: SqlModelingTableQuery,
});

export function SqlModelingProviders(
  options: { feature: boolean; datasource: boolean; job: boolean; dataTest: boolean; impex: boolean } = {
    feature: true,
    datasource: true,
    job: true,
    dataTest: true,
    impex: true,
  },
): StaticProvider[] {
  return [
    options.feature ? provideFeature(SqlModellingFeatureProviders()) : [],
    options.datasource ? provideDatasource(SqlModellingDatasourceProviders()) : [],
    options.job ? provideJob(SqlModellingJobProviders()) : [],
    options.dataTest ? provideDataTest(SqlModelingDataTestProviders()) : [],
    options.impex ? provideImpex(SqlModelingImpexProviders()) : [],
  ];
}
